export const getGroupRoutes = (routes) => {
  const groups = [];
  const indexByName = new Map();

  routes.forEach((item) => {
    const groupName = item.group || "Other";
    if (!indexByName.has(groupName)) {
      indexByName.set(groupName, groups.length);
      groups.push({ name: groupName, items: [] });
    }
    groups[indexByName.get(groupName)].items.push(item);
  });

  return groups;
};
